import { ReactElement, memo } from 'react';
import { FlowItemArrayType } from '../../../../../shared/model/flow.types';
import { MultipassScheduleTableView } from './table-view/multipass-schedule-table-view';
import './multipass-schedule.css';

export interface MultipassScheduleProps {
  rootPass: FlowItemArrayType[];
  numberOfPasses: number;
  disabled?: boolean;
  presentingEl?: HTMLElement;
  forceFullScreenModals?: boolean;
}

const MultipassSchedule = memo(function MultipassSchedule(
  props: MultipassScheduleProps
): ReactElement {
  return (
    <div id="multipass-schedule">
      <MultipassScheduleTableView {...props} />
    </div>
  );
});

export { MultipassSchedule };
